import React from 'react'
import { Link } from 'react-router-dom'

const Footer: React.FC<any> = () => {
  return (
    <div className="w-full footer font-roboto mt-6">
      <div className="flex flex-col space-y-2 items-center justify-center w-full pt-14 pb-12">
        <div className="space-x-8 flex">
          <Link
            to="https://www.unsw.edu.au/about-us/"
            style={{ textDecoration: 'none' }}
          >
            About UNSW
          </Link>
          <Link
            to="https://www.unsw.edu.au/privacy"
            style={{ textDecoration: 'none' }}
          >
            Privacy Policy
          </Link>
          <Link
            to="https://www.unsw.edu.au/copyright-disclaimer"
            style={{ textDecoration: 'none' }}
          >
            Copyright and Disclaimer
          </Link>
          <Link
            to="https://www.unsw.edu.au/about-us/our-story/contact-us"
            style={{ textDecoration: 'none' }}
          >
            Contact Us
          </Link>
        </div>
      </div>
    </div>
  )
}

export default Footer
